module.exports = __webpack_public_path__ + "static/media/golang.14e869f7.svg";